

export const TRACK_EXTERNAL_LINK_CLICK = '@@storefront/TRACK_EXTERNAL_LINK_CLICK';


export function trackExternalLinkClick(eventData) {
    return {
        type: TRACK_EXTERNAL_LINK_CLICK,
        meta: {
            segment: {
                eventAction: 'External Link Clicked',
                eventData
            }
        }
    };
}
